<!-- src/app/admin/views/company/add-external-user/add-external-user.component.html -->
<section class="mss-bg" [hidden]="signupSuccess">
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="card-scroll">
      <div class="row">
        <div class="col-lg-4">
          <label
            class="block text-900 font-medium mb-2 ms-label-view"
            for="fName"
            >{{ "First Name" | translator }}
          </label>
          <input
            type="text"
            id="fName"
            placeholder="{{ 'Type the first name' | translator }}"
            pattern="[\u0600-\u06FF\s]+"
            formControlName="fName"
            pInputText
            class="w-full mb-3"
          />
          <div
            class="error"
            *ngIf="
              myForm.controls['fName'].invalid &&
              (myForm.controls['fName'].dirty ||
                myForm.controls['fName'].touched)
            "
          >
            <div *ngIf="myForm.controls['fName'].errors?.['required']">
              {{ "The name is required" | translator }}
            </div>
            <div *ngIf="myForm.controls['fName'].errors?.['pattern']">
              {{ "Please write in Arabic" | translator }}
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <label
            class="block text-900 font-medium mb-2 ms-label-view"
            for="mName"
            >{{ "the second name" | translator }}</label
          >
          <input
            type="text"
            id="mName"
            placeholder="{{ 'Type the second name' | translator }}"
            pattern="[\u0600-\u06FF\s]+"
            formControlName="mName"
            pInputText
            class="w-full mb-3"
          />
          <div
            class="error"
            *ngIf="
              myForm.controls['mName'].invalid &&
              (myForm.controls['mName'].dirty ||
                myForm.controls['mName'].touched)
            "
          >
            <div *ngIf="myForm.controls['mName'].errors?.['required']">
              {{ "The name is required" | translator }}
            </div>
            <div *ngIf="myForm.controls['mName'].errors?.['pattern']">
              {{ "Please write in Arabic" | translator }}
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <label
            class="block text-900 font-medium mb-2 ms-label-view"
            for="lName"
            >{{ "family name" | translator }}</label
          >
          <input
            type="text"
            id="lName"
            placeholder="{{ 'Type the last name' | translator }}"
            pattern="[\u0600-\u06FF\s]+"
            formControlName="lName"
            pInputText
            class="w-full mb-3"
          />
          <div
            class="error"
            *ngIf="
              myForm.controls['lName'].invalid &&
              (myForm.controls['lName'].dirty ||
                myForm.controls['lName'].touched)
            "
          >
            <div *ngIf="myForm.controls['lName'].errors?.['required']">
              {{ "The name is required" | translator }}
            </div>
            <div *ngIf="myForm.controls['lName'].errors?.['pattern']">
              {{ "Please write in Arabic" | translator }}
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <label
            class="block text-900 font-medium mb-2 ms-label-view"
            for="email"
            >{{ "E-mail address" | translator }}</label
          >
          <input
            type="email"
            id="email"
            placeholder="{{ 'Type the email address' | translator }}"
            formControlName="email"
            pInputText
            class="w-full mb-3 text-start"
          />
          <div
            class="error"
            *ngIf="
              myForm.controls['email'].invalid &&
              (myForm.controls['email'].dirty ||
                myForm.controls['email'].touched)
            "
          >
            <div *ngIf="myForm.controls['email'].errors?.['required']">
              {{ "Email required" | translator }}
            </div>
            <div *ngIf="myForm.controls['email'].errors?.['email']">
              {{ "Email is invalid" | translator }}
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <label
            class="block text-900 font-medium mb-2 ms-label-view"
            for="phone"
            >{{ "Mobile Phone Number" | translator }}</label
          >
          <input
            type="text"
            id="phone"
            placeholder="--------- 966 00"
            formControlName="phone"
            pInputText
            class="w-full mb-3"
          />
          <div
            class="error"
            *ngIf="
              myForm.controls['phone'].invalid &&
              (myForm.controls['phone'].dirty ||
                myForm.controls['phone'].touched)
            "
          >
            <div *ngIf="myForm.controls['phone'].errors?.['required']">
              {{ "Mobile phone number is required" | translator }}
            </div>
            <div *ngIf="myForm.controls['phone'].errors?.['pattern']">
              {{ "Invalid mobile phone number" | translator }}
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-6">
          <label
            class="block text-900 font-medium mb-2 ms-label-view"
            for="national_id"
            >{{ "National Identity" | translator }}</label
          >
          <input
            type="text"
            id="national_id"
            placeholder="xxxxxxxxxx"
            formControlName="national_id"
            pInputText
            class="w-full mb-3"
          />
          <div
            class="error"
            *ngIf="
              myForm.controls['national_id'].invalid &&
              (myForm.controls['national_id'].dirty ||
                myForm.controls['national_id'].touched)
            "
          >
            <div *ngIf="myForm.controls['national_id'].errors?.['required']">
              {{ "National ID is required" | translator }}
            </div>
            <div *ngIf="myForm.controls['national_id'].errors?.['pattern']">
              {{ "The national ID is invalid" | translator }}
            </div>
          </div>
        </div> -->
        <div class="col-lg-6">
          <label
            class="block text-900 font-medium mb-2 ms-label-view"
            for="gender"
            >{{ "Sex" | translator }}</label
          >
          <p-dropdown
            id="gender"
            [options]="gender"
            placeholder="{{ 'Choose gender' | translator }}"
            formControlName="gender"
            styleClass=" sstarabic w-100"
          >
            <ng-template let-item pTemplate="item">
              <i [ngClass]="item.icon"></i>
              {{ item.label }}
            </ng-template>
          </p-dropdown>
        </div>

        <div *ngIf="addCompany" class="col-lg-6">
          <label
            class="block text-900 font-medium mb-2 ms-label-view"
            for="gender"
            >{{ "External Company" | translator }}</label
          >
          <p-autoComplete
            class="v4-auto-complete"
            [dropdown]="true"
            [suggestions]="filteredCompanies"
            field="label"
            field="name"
            (completeMethod)="filterCountry($event)"
            formControlName="company"
            appendTo="body"
          />
        </div>
      </div>
    </div>
    <p *ngIf="message" class="message">{{ message }}</p>
    <button
      [hidden]="type != 'CREATE' && type != 'SIGNUP'"
      type="submit"
      [disabled]="!myForm.valid"
      class="w-full v4-btn-every py-2"
    >
      <i class="pi pi-user-plus v4-ml-2"></i>{{ "construction" | translator }}
    </button>
    <span [hidden]="type != 'UPDATE'">
      <button
        type="submit"
        [disabled]="!myForm.valid"
        class="w-full v4-btn-every py-2"
      >
        <i class="pi pi-user-edit v4-ml-2"></i>{{ "to update" | translator }}
      </button>
    </span>
  </form>
</section>
<section [hidden]="!signupSuccess && type == 'SIGNUP'">
  <p>{{ this.message }}</p>
</section>
